export default __webpack_public_path__ + "../img/5427d9715adc0d54f66199216d7857c3.png";